import React from 'react';
import ReactImageFallback from 'react-image-fallback';
import PropTypes from 'prop-types';
import {
  FALLBACK_ICON,
} from '../../../../utils';

function MultiProfileListing(props) {
  const { artistDetail } = props;
  return (
    <div className="admin-message-head-profile multi">
      {artistDetail.map((el) => (
        <span key={el._id}>
          <ReactImageFallback
            src={el.artistImage}
            fallbackImage={FALLBACK_ICON}
            alt="profile"
            className="image-cover"
          />
        </span>
      ))}

    </div>
  );
}
MultiProfileListing.propTypes = {

  artistDetail: PropTypes.arrayOf(PropTypes.shape({
    artistImage: PropTypes.string,
    _id: PropTypes.string,
  })).isRequired,
};
export default React.memo(MultiProfileListing);
